module.exports = ".auto-map-transform-card {\r\n    margin: 10px auto;\r\n}\r\n.auto-spinner {\r\n    margin-left: 10px;\r\n}\r\n.mat-card-title  {\r\n    font-size: 22px;\r\n    margin-left: -10px;\r\n    margin-top: 10px; \r\n    margin-bottom: 30px; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/map-format-transform-s3/map-format-transform-s3.component.css
// module id = ./src/app/map-format-transform-s3/map-format-transform-s3.component.css
// module chunks = main